import React from 'react'

const SettingPage = React.lazy(() => import('pages/Setting/pages/SettingPage'));


const SettingPageRoutes = [
    {
        path: '/app-setting',
        exact: true,
        name: 'Cài đặt hệ thống',
        function: 'SYS_APPCONFIG_VIEW',
        component: SettingPage,
    }
    
]

export default SettingPageRoutes
